import { Endpoint } from '@business/api/endpoint';
import { SubcontractorEmailTemplateResponse } from '@business/entities/subcontractorEmailTemplate';
import { CommonService } from '@business/services';
import { EmailTemplateSettingsFormData } from '@modules/settings/SettingsPage/Components/SubcontractorTab/Tabs/SubContractorEmailTemplate';

export function fetchSettings() {
  return Endpoint.get<SubcontractorEmailTemplateResponse>(`@gc/subcontractor-email-template`);
}

export function saveSettings(data: EmailTemplateSettingsFormData) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<SubcontractorEmailTemplateResponse>(`@gc/subcontractor-email-template`, { formData, hasFiles: true });
}
